import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { commonLocalization, projectsLocalization, number } from "localization";
import ScrollArea from "react-scrollbar";
import styled from "styled-components";

class ProjectProgress extends Component {
  state = {
    title: "desc",
    budget: ""
  };

  goToDetail = projectId => {
    this.props.history.push(`/projects/${projectId}`);
  };

  sortByType(type) {
    if (this.state[type] === "" || this.state[type] === "desc") {
      // sort data in ascending order
      this.setState({ [type]: "asc" }, () =>
        this.props.sortByType(type, this.state[type])
      );
    } else {
      // sort in descending
      this.setState({ [type]: "desc" }, () =>
        this.props.sortByType(type, this.state[type])
      );
    }
  }

  render() {
    const { projects, selectedLanguage, fetching } = this.props;
    const {
      projectTable: { title: projecttabletWideitle }
    } = projectsLocalization[selectedLanguage];

    const { progress, physical, financial } = commonLocalization[
      selectedLanguage
    ];

    const { title } = this.state;

    return (
      <TableWrapper
        className="table-wrap"
        lang={selectedLanguage}
        projecttabletWideitle={projecttabletWideitle}
        progress={progress}
        physical={physical}
        financial={financial}
      >
        <table>
          <thead>
            <tr>
              <th
                onClick={() => this.sortByType("title")}
                width="65%"
                className={title === "asc" ? "asc" : "desc"}
              >
                {projecttabletWideitle}
              </th>
              <th width="35%">
                {progress} (
                <span className="title__progress title__progress--physical">
                  {physical}
                </span>
                /
                <span className="title__progress title__progress--financial">
                  {financial}
                </span>
                )
              </th>
            </tr>
          </thead>
        </table>
        <ScrollArea
          className="options"
          smoothScrolling={true}
          minScrollSize={30}
        >
          <table>
            <tbody>
              {projects.length > 0 &&
                !fetching &&
                projects.map((project, index) => (
                  <tr key={index} onClick={() => this.goToDetail(project.id)}>
                    <td width="65%">
                      <Link to={`/projects/${project.id}`}>
                        {project.title}
                      </Link>
                    </td>
                    <td width="35%">
                      <div className="progress__bar--line">
                        <div className="progress__total">
                          <span
                            style={{
                              width: `${project.physical_progress}%`
                            }}
                            className={
                              project.physical_progress === 100
                                ? "progress progress__physical progress__total--physical"
                                : "progress progress__physical"
                            }
                          />
                        </div>
                        <span>
                          {number(project.physical_progress.toFixed(0))}%
                        </span>
                      </div>
                      <div className="progress__bar--line">
                        <div className="progress__total">
                          <span
                            style={{
                              width: `${project.financial_progress}%`
                            }}
                            className={
                              project.financial_progress === 100
                                ? "progress progress__financial progress__total--financial"
                                : "progress progress__financial"
                            }
                          />
                        </div>
                        <span>
                          {number(project.financial_progress.toFixed(0))}%
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </ScrollArea>
      </TableWrapper>
    );
  }
}

const TableWrapper = styled.div`
  table tr th {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    padding-bottom: 6px;
    &.asc,
    &.desc {
      background-position: ${props =>
        props.lang === "en" ? "left 21px" : "left 23px"};
    }
  }
  table tr td {
    font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
    .status {
      font-size: ${props => (props.lang === "en" ? "12px" : "13px")};
      padding: ${props => (props.lang === "en" ? "4px 10px" : "2px 10px")};
    }
  }
  .progress__bar--line > span {
    font-size: ${props => (props.lang === "en" ? "10px" : "11px")};
  }
  @media only screen and (max-width: 768px) {
    td:before {
      font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    }
    td:nth-of-type(1):before {
      content: ${props => "'" + props.projecttabletWideitle + "'"};
    }
    td:nth-of-type(2):before {
      content: ${props =>
        "'" +
        props.progress +
        "(" +
        props.physical +
        " /" +
        props.financial +
        ")" +
        "'"};
    }
  }
`;

const mapStateToProps = state => ({
  selectedLanguage: state.localizationReducers.selectedLanguage,
  fetching: state.infraMonitor.fetching
});

export default withRouter(connect(mapStateToProps)(ProjectProgress));



// WEBPACK FOOTER //
// ./src/pages/project/list/partials/project-progress.js